var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrmContentDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0375 14.7784C20.0439 14.7784 21.009 14.389 21.7206 13.696C22.4323 13.003 22.832 12.0631 22.832 11.083C22.832 10.1029 22.4323 9.16302 21.7206 8.47001C21.009 7.777 20.0439 7.38767 19.0375 7.38767H17.9534C18.1116 6.70135 18.114 5.99443 17.9605 5.30729C17.807 4.62015 17.5005 3.96624 17.0587 3.38289C16.6169 2.79955 16.0483 2.29819 15.3853 1.90745C14.7224 1.51671 13.9782 1.24423 13.1952 1.10558C12.4121 0.96693 11.6056 0.964818 10.8216 1.09937C10.0376 1.23391 9.29157 1.50249 8.62602 1.88975C7.28187 2.67186 6.34725 3.88995 6.02777 5.27604C4.87202 5.23096 3.73538 5.56154 2.81248 6.21118C1.88958 6.86082 1.23782 7.78911 0.968788 8.83712C0.699755 9.88512 0.830188 10.9877 1.33775 11.9559C1.84532 12.9242 2.69844 13.698 3.75106 14.1449",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4492 9.49609V18.9984",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19727 15.832L11.4497 18.9995L14.7021 15.832",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmContentDownload);
export default __webpack_public_path__ + "static/media/crm-content-download.25a82aa08e8ded5b680ee0f04e2c0e05.svg";
export { ForwardRef as ReactComponent };